import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import { TOOLBOX_REPORT_STATUS } from "utils/CommonUtils";
import { useGetProjectsByDropDownQuery } from "slices/projects/projectSlice";

export const ToolBoxListGlobalFilter = ({ setPageState, globalValue }: any) => {
  const { data: Projects } = useGetProjectsByDropDownQuery(undefined);
  const [dateRange, setDateRange] = useState([null, null]);

  const statusOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      status: value,
      page: 1,
    }));
  };

  const projectsOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      projects: value,
      page: 1,
    }));
  };

  const handleDateChange = (selectedDates: any) => {
    if (selectedDates.length === 2) {
      const [startDate, endDate] = selectedDates;
      setDateRange([startDate, endDate]);

      let startDateString = startDate.toISOString().split("T")[0];
      let dueDateString = endDate.toISOString().split("T")[0];

      setPageState((prev: any) => ({
        ...prev,
        start_date_of_work: startDateString,
        end_date_of_work: dueDateString,
      }));
    }
  };

  const handleBlur = () => {
    // If the date range is not set, clear the date range
    if (dateRange[0] && dateRange[1]) {
      setDateRange([null, null]);
      setPageState((prev: any) => ({
        ...prev,
        start_date_of_work: "",
        end_date_of_work: "",
      }));
    }
  };

  return (
    <React.Fragment>
      <div className="col-xxl-3 col-sm-4">
        <Flatpickr
          placeholder="Select start & due date range"
          className="form-control bg-light border-light"
          options={{
            mode: "range",
            dateFormat: "d-m-Y",
          }}
          value={dateRange}
          onChange={handleDateChange}
          onClose={handleBlur}
        />
      </div>

      <div className="col-xxl-3 col-sm-4">
        <div className="input-light">
          <select
            onChange={(e) => projectsOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="status"
            id="idStatus"
          >
            <option value="">Projects</option>
            {Projects?.map((options: any) => (
              <option key={options.id} value={options.project_name}>
                {options.project_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="col-xxl-3 col-sm-4">
        <div className="input-light">
          <select
            onChange={(e) => statusOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="status"
            id="idStatus"
          >
            <option value="">All</option>
            {TOOLBOX_REPORT_STATUS?.map((options: any) => (
              <option key={options.id} value={options.id}>
                {options.status_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
};
